// extracted by mini-css-extract-plugin
export default {"base":"user_base__nRpx+","user-image-input":"user_user-image-input__mj788","submit-button":"user_submit-button__FNC3I","logout-button":"user_logout-button__xMRRa"};